import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import extractFormData from "../../../utils/extractFormData";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpCaptcha from "../../common/AmpCaptcha/AmpCaptcha";
import AmpCheckBox from "../../common/AmpCheckBox/AmpCheckBox";
import AmpFormError from "../../common/AmpFormError/AmpFormError";

export interface AttestationMailingAddressProps {
    submissionData: Record<string, unknown>
    callback: (submissionData: Record<string, unknown>) => void;
}

export default function AttestationMailingAddress(props: AttestationMailingAddressProps) {
    const { t } = useTranslation(["property", "login"]);
    const onSubmit = (e: React.FormEvent) => {
        
        setNoAgree(false);
        setNoCaptcha(false);
        e.preventDefault();
        const formdata= extractFormData(e);
        console.log(formdata)
        if (!isChecked){
            setNoAgree(true);
        }
        else if (!formdata["g-recaptcha-response"] && process.env.REACT_APP_DISABLE_CAPTCHA !== "1"){
            setNoCaptcha(true)
        } else {
            const data = props.submissionData;
            data["g-recaptcha-response"] = formdata["g-recaptcha-response"];
            props.callback(data);
        }
    }
    const [noAgree, setNoAgree] = useState(false);
    const [noCaptcha, setNoCaptcha] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const onAgree = (e: React.ChangeEvent) => {
        setIsChecked((e.currentTarget as HTMLInputElement).checked)
    }

    return (
        <form className="attestation-form" onSubmit={(e) => onSubmit(e)}>
            <div className="attestation-content">
                <p>
                    {t("mailing.attet1")}
                </p><p>                                                                        
                        <Trans  defaults={t("mailing.attet2")}>
                        {/* eslint-disable-next-line */}
                            <a className="amp-anchor" target="_blank" rel="noopener noreferrer"></a>
                        </Trans>
                </p><p>
                    {t("mailing.attet3")}
                </p>
                <AmpCheckBox 
                    handleCheck={(e) => onAgree(e)} id={"attestation-agree"} label={t("mailing.agree")} hasToolTip={false} toolTip={""}/>
                <AmpCaptcha/>
                <AmpFormError errorMessage={"Please agree to the Attestation"} error={noAgree}/>
                <AmpFormError errorMessage={"Please verify captcha"} error={noCaptcha}/>
            </div>
            <div className="attestation-bottom">
                <AmpButton 
                onClick={() => null} type={"submit"} text={t("submit", {"ns": "login"})}/>
            </div>
        </form>
    )
}